<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-more-input (focussed$)="onFocussed($event)" *ngSwitchDefault></fui-edit-more-input>
    <fui-filter-more-input [control]="control" [disabled]="disabled" [field]="valueField"
                           (focussed$)="onFocussed($event)" #input [key]="labelField" [label]="label"
                           [(ngModel)]="value" *ngSwitchCase="contextType.FILTER" [options]="options"
                           [placeholder]="placeholder">
        <fui-icon *ngIf="icon" [icon]="icon" [height]="iconSize" [width]="iconSize"></fui-icon>
    </fui-filter-more-input>
    <fui-header-more-input [control]="control" [disabled]="disabled" [field]="valueField"
                           (focussed$)="onFocussed($event)" #input [key]="labelField" [label]="label"
                           [(ngModel)]="value" *ngSwitchCase="contextType.HEADER" [options]="options"
                           [placeholder]="placeholder">
        <fui-icon *ngIf="icon" [icon]="icon" [height]="iconSize" [width]="iconSize"></fui-icon>
    </fui-header-more-input>
    <fui-inline-more-input (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.INLINE"></fui-inline-more-input>
    <fui-more-pill (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.PILL"></fui-more-pill>
    <fui-pop-more-input (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.POP"></fui-pop-more-input>
</ng-container>
